import { CREDIT_CARDS_ON_FILE_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = {};

export default function creditCardsOnFile(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case CREDIT_CARDS_ON_FILE_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
